







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class Logo extends Vue {
    @Prop({ default: 'Back' }) public buttonText!: string;
    @Prop() public buttonCallback!: () => void;
}
